import { FleekError } from './FleekError';

type UnknownErrorOptions = Record<string, never>;

export class UnknownError extends FleekError<UnknownErrorOptions> {
  public name = 'UnknownError';

  constructor() {
    super({});
  }

  toString = () => `Unexpected error. Repeat the action or contact support.`;
}
